/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 電梯資料功能頁面
 * @module ElevatorContainer
 */

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
    AccessModeEnums,
} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
//import Sidebar from '../../features/main-frame/components/Sidebar';
import ElevatorPage from './components/ElevatorPage';
import ElevatorModal from './components/ElevatorModal';
import FloorListModal from './components/FloorListModal';
import { AlertModal, AlertModalModeEnums } from '../../components/AlertModal';
import { MessageModal, MessageModalModeEnums } from '../../components/MessageModal';

// ----- import from local actions -----
import {
    fetchBuildingSelection,
} from '../../redux/actions/BuildingActions';
import {
    addElevator,
    editElevator,
    editElevatorStatus,
    fetchElevator,
    fetchElevatorList,
    fetchElevatorSelection,
} from '../../redux/actions/ElevatorActions';
import { 
    fetchFloorList,
    saveFloor
} from 'web/redux/actions/FloorActions';

// ----- constants and enums -----
const ElevatorModalModeEnums = {
    NEW: 'new',
    EDIT: 'edit',
};

const ACTION_TARGET_ELEVATOR = 'elevator';

const RESPONSE_OK = 200;
const TITLE_ELEVATOR_STATUS = '修改電梯狀態';

class ElevatorContainer extends BaseComponent {
    constructor(props) {
        super(props);
        // 创建 ref
        this.elevatorModalRef = React.createRef();
        this.floorListModalRef = React.createRef();
        this.alertModalRef = React.createRef();
        this.messageModalRef = React.createRef();
        this.elevatorModal = null;
        this.floorListModal = null;
        this.alertModal = null;
        this.messageModal = null;

        this.state = {
            needElevatorLoad: false,
            needFloorListLoad: false,
            elevatorModalMode: ElevatorModalModeEnums.NEW,
            actionMode: AlertModalModeEnums.ENABLE,
            actionTarget: '',
            elevator: null,
            elevatorId: null,
            alertMessage: '',
            actionIds: [],
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: ''},
            search: { buildingId: 0, elevatorName: '', elevatorId: 0 },
        };
        this.toggleElevatorModal = this.toggleElevatorModal.bind(this);
        this.toggleFloorListModal = this.toggleFloorListModal.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    toggleElevatorModal(isShow, mode = ElevatorModalModeEnums.NEW, index = null) {
        if (this.elevatorModal) {
            if (mode === ElevatorModalModeEnums.EDIT) {
                this.setState({ elevator: this.props.elevatorList[index] });
            } else {
                this.setState({ elevator: null });
            }

            if (isShow) {
                this.elevatorModal.show();
            } else {
                this.elevatorModal.hide();
            }
            this.setState({ elevatorModalMode: mode });
        }
    }

    toggleFloorListModal(isShow, index = null) {
        if (this.floorListModal) {
            if (index !== null) {
                const elevator = this.props.elevatorList[index];
                this.setState({ elevator: elevator });
                this.props.fetchFloorList(elevator.elevatorId).then(() => {
                    this.setState({ needFloorListLoad: true });
                });
            }
            if (isShow) {
                this.floorListModal.show();
            } else {
                this.floorListModal.hide();
            }
        }
    }

    toggleAlertModal(isShow, mode = AlertModalModeEnums.ENABLE, target, message = '', elevatorIds = []) {
        if (this.alertModal) {
            if (isShow) {
                let alertMessage = message;
                if (alertMessage === '') {
                    let length = elevatorIds.length;
                    if (mode === AlertModalModeEnums.ENABLE) {
                        alertMessage = `啟用 [ ${length} ] 筆資料`;
                    } else if (mode === AlertModalModeEnums.DISABLE) {
                        alertMessage = `停用 [ ${length} ] 筆資料`;
                    }
                }
                this.setState({ actionMode: mode });
                this.setState({ alertMessage: alertMessage });
                this.setState({ actionTarget: target});
                this.setState({ actionIds: elevatorIds });
                this.alertModal.show();
            } else {
                this.alertModal.hide();
            }
        }
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.INFO, title = '', message = '') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    onConfirm() {
        const actionTarget = this.state.actionTarget;
        const actionMode = this.state.actionMode;
        const actionIds = this.state.actionIds;

        if (actionTarget === ACTION_TARGET_ELEVATOR) {
            if (actionMode === AlertModalModeEnums.ENABLE || actionMode === AlertModalModeEnums.DISABLE) {
                let status = actionMode === AlertModalModeEnums.ENABLE ? 'A' : 'I';
                this.props.editElevatorStatus(actionIds, status).then((response) => {
                    const statusCode = response.payload.code;
                    if (statusCode !== RESPONSE_OK) {
                        const message = `[ ${statusCode} ] ${response.payload.message}`;
                        this.toggleAlertModal(false);
                        this.toggleMessageModal(true, MessageModalModeEnums.ERROR, TITLE_ELEVATOR_STATUS, message);
                    } else {
                        const { buildingId, elevatorName, elevatorId } = this.state.search;
                        this.props.fetchElevatorList(buildingId, elevatorName, elevatorId).then(() => {
                            this.setState({ needElevatorLoad: true });
                            this.toggleAlertModal(false);
                        });
                    }
                });
            }
        }
    }

    componentDidMount() {
        // 頁面所需資料初始化
        this.props.fetchBuildingSelection();
        this.props.fetchElevatorList(0, '', 0).then(() => {
            this.setState({ needElevatorLoad: true });
        });
        this.elevatorModal = new bootstrap.Modal(this.elevatorModalRef.current);
        this.floorListModal = new bootstrap.Modal(this.floorListModalRef.current);
        this.alertModal = new bootstrap.Modal(this.alertModalRef.current);
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }
    
    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount() {
        this.toggleElevatorModal(false);
        this.toggleFloorListModal(false);
        this.toggleAlertModal(false);
        this.toggleMessageModal(false);
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {/* <Sidebar /> */}
                        <ElevatorPage
                            {...this.props}
                            needElevatorLoad={this.state.needElevatorLoad}
                            setNeedElevatorLoad={(bLoad) => this.setState({ needElevatorLoad: bLoad })}
                            onNewElevator={() => this.toggleElevatorModal(true, ElevatorModalModeEnums.NEW)}
                            onEditElevator={(index) => this.toggleElevatorModal(true, ElevatorModalModeEnums.EDIT, index)}
                            onEditElevatorStatus={(mode, message, elevatorId) => this.toggleAlertModal(true, mode, ACTION_TARGET_ELEVATOR, message, [elevatorId])}
                            onBatchHandle={(mode, elevatorIds) => this.toggleAlertModal(true, mode, ACTION_TARGET_ELEVATOR, '', elevatorIds)}
                            setSearchElevator={(buildingId, elevatorName, elevatorId) => {
                                this.setState({ search: { buildingId: buildingId, elevatorName: elevatorName, elevatorId: elevatorId }});
                            }}
                            onFloorList={(index) => {
                                this.toggleFloorListModal(true, index);
                            }}
                        />
                    </div>
                </div>
                <Footer />
                <FloorListModal 
                    {...this.props}
                    ref={this.floorListModalRef}
                    checkPermission={this.checkPermission.bind(this)}
                    elevator={this.state.elevator}
                    needFloorListLoad={this.state.needFloorListLoad}
                    setNeedFloorListLoad = {(bLoad) => this.setState({ needFloorListLoad: bLoad })}
                    onShowMessageModal={(mode, title, message) => {
                        this.toggleMessageModal(true, mode, title, message);
                        this.toggleFloorListModal(false);
                    }}
                />
                <ElevatorModal 
                    {...this.props}
                    ref={this.elevatorModalRef}
                    mode={this.state.elevatorModalMode}
                    elevator={this.state.elevator}
                    searchElevator={this.state.search}
                    setNeedElevatorLoad={(bLoad) => this.setState({ needElevatorLoad: bLoad })}
                    onErrorHandle={(title, message) => this.toggleMessageModal(true, MessageModalModeEnums.ERROR, title, message)}
                />
                <AlertModal
                    ref={this.alertModalRef}
                    mode={this.state.actionMode}
                    message={this.state.alertMessage}
                    onConfirm={() => this.onConfirm()}
                    onCancel={() => this.setState({ needElevatorLoad: true })}
                />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
            </React.Fragment>
        );
    }
}

ElevatorContainer.propTypes = {
    userPermissions: PropTypes.array,
    buildingSelection: PropTypes.array,
    elevatorList: PropTypes.array,
    floorList: PropTypes.array,
};

ElevatorContainer.defaultProps = {
    userPermissions: [],
    buildingSelection: [],
    elevatorList: [],
    floorList: []
};

function mapStateToProps(state) {
    return {
        userPermissions: state.access.userPermissions,
        buildingSelection: state.building.buildingSelection.data,
        elevatorList: state.elevator.elevatorList.data,
        floorList: state.floor.floorList.data,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchBuildingSelection: () => {
            return dispatch(fetchBuildingSelection());
        },
        addElevator: (elevator) => {
            return dispatch(addElevator(elevator));
        },
        editElevator: (elevator) => {
            return dispatch(editElevator(elevator));
        },
        editElevatorStatus: (elevatorIds, status) => {
            return dispatch(editElevatorStatus({ elevatorIds, status} ));
        },
        fetchElevator: (elevatorId) => {
            return dispatch(fetchElevator(elevatorId));
        },
        fetchElevatorList: (buildingId, elevatorName, elevatorId) => {
            return dispatch(fetchElevatorList({ buildingId, elevatorName, elevatorId }));
        },
        fetchFloorList: (elevatorId) => {
            return dispatch(fetchFloorList({ elevatorId }));
        },
        saveFloor: (floor) => {
            return dispatch(saveFloor(floor));
        },
    };    
}

export default connect(mapStateToProps, mapDispatchToProps)(ElevatorContainer);